const isTaxoArchive = document.querySelector('.is-taxo-archive');
(function ($) {
    $(document).ready(function () {

        if (isTaxoArchive) {
            const notFoundContainer = $('.not-found').clone();
            $('.not-found').remove();
            const filterContainer = $('.archive-item-filter');
            const filterForm = $('.items-filter__filter-posts-form');
            let currentPage = 1;
            let nonce = $(filterForm).find('input[name="nonce"]').val();
            let action = $(filterForm).find('input[name="action"]').val();
            let ajaxUrl = $(filterForm).attr('action');

            let archiveTaxonomy = $('.archive-main').attr('data-taxo');
            let archiveTaxonomyValue = $('.archive-main').attr('data-taxo-value');

            let values = {
                post_type: ['*'],
                post_tag: ['*'],
                frge_profile: ['*'],
                search: '',
                taxonomy: archiveTaxonomy,
                taxonomyValue: archiveTaxonomyValue
            }

            if ($('.archive-main').attr('data-search') !== undefined) {
                values.search = $('.archive-main').attr('data-search');
            }
            $('.items-filter__dropdown-choices > span').click(function () {
                let taxoVal = $(this).attr('data-value');
                let taxoName = $(this).attr('data-name');

                if (taxoVal === '*') {
                    values[taxoName] = ['*'];
                    $(this).parent().find('span').removeClass('is-selected');
                    $(this).addClass('is-selected');
                } else {
                    values[taxoName] = values[taxoName].filter((item) => item !== '*');
                }

                //Si la taxoVal est déjà dans le tableau, on l'enlève l'objet correspondant du tableau sinon on l'ajoute

                if (values[taxoName].includes(taxoVal)) {
                    values[taxoName] = values[taxoName].filter((item) => item !== taxoVal);
                }
                else {
                    values[taxoName].push(taxoVal);
                }

                if (values[taxoName].length === 0) {
                    values[taxoName].push('*');
                }

                // Nouveau filtre : retour à la première page
                currentPage = 1;
                ajaxUrl = $(filterForm).attr('action');

                fetchPosts(ajaxUrl, values, nonce, action);

                //On ajoute la classe active à l'élément qui a data-page=currentpage
                const crossIcon = '<svg stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="items-filter__cross-icon"><path d="M9.17218 14.8284L12.0006 12M14.829 9.17157L12.0006 12M12.0006 12L9.17218 9.17157M12.0006 12L14.829 14.8284" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
                $(this).toggleClass('is-selected');
                if ($(this).hasClass('is-selected')) {
                    $(this).prepend(crossIcon);
                }
                else {
                    $(this).find('svg').remove();
                }

            })

            // Gabarit des listings : chevrons de la maquette, fournis par #pagination[data-icon-prev|next]
            function paginationIcon(direction) {
                const src = $('#pagination').attr('data-icon-' + direction);
                return src ? $('<img>').attr({ src: src, alt: '', width: 24, height: 24 }) : '';
            }

            // Changement de page : retour en haut de la liste, sous l'en-tête fixe
            function scrollToResults() {
                const body = document.querySelector('.frge-listing__body');
                const top = body ? Math.max(0, $(body).offset().top - $('.header__top').outerHeight()) : 0;
                $('html, body').animate({ scrollTop: top }, 500);
            }

            function createPagination(maxPages) {
                let pagination = $('#pagination');
                pagination.html('');
                let paginationList = $('<ul>').addClass('pagination__list');
                pagination.append(paginationList);

                let displayPages = maxPages;
                if (displayPages > 6) {
                    displayPages = 6;
                }

                let startPage = 1;
                if (currentPage > 6) {
                    startPage = currentPage - 1;
                }

                if (currentPage > maxPages - 5 && maxPages - 5 > 0) {
                    startPage = maxPages - 5;
                }

                for (let i = startPage; i <= maxPages && i < startPage + 6; i++) {
                    let paginationItem = $('<li>').addClass('pagination__item');
                    paginationItem.attr('data-page', i);
                    paginationList.append(paginationItem);
                    let paginationLink = $('<a>').addClass('pagination__link')
                        .attr('href', '#')
                        .text(i);
                    paginationItem.append(paginationLink);

                    if (i === currentPage) {
                        paginationItem.addClass('active');
                    }

                    $(paginationItem).click(function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        ajaxUrl = $(filterForm).attr('action');
                        ajaxUrl = ajaxUrl + '?page=' + page;
                        currentPage = page;
                        scrollToResults();

                        fetchPosts(ajaxUrl, values, nonce, action);
                    });
                }

                if (startPage + 5 < maxPages && maxPages > 6) {
                    let paginationItem = $('<li>').addClass('pagination__item');
                    paginationList.append(paginationItem);
                    let paginationLink = $('<span>').addClass('pagination__link')
                        .text('...');
                    paginationItem.append(paginationLink);
                    let paginationItemLast = $('<li>').addClass('pagination__item pagination__item--edge');
                    paginationItemLast.attr('data-page', maxPages);
                    paginationList.append(paginationItemLast);
                    let paginationLinkLast = $('<a>').addClass('pagination__link')
                        .attr('href', '#')
                        .text(maxPages);
                    paginationItemLast.append(paginationLinkLast);
                    paginationItemLast.click(function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        ajaxUrl = $(filterForm).attr('action');
                        ajaxUrl = ajaxUrl + '?page=' + page;
                        currentPage = page;
                        scrollToResults();

                        fetchPosts(ajaxUrl, values, nonce, action);
                    });
                } else if (maxPages > 6) {
                    let paginationItem = $('<li>').addClass('pagination__item');
                    paginationList.prepend(paginationItem);
                    let paginationLink = $('<span>').addClass('pagination__link')
                        .text('...');
                    paginationItem.append(paginationLink);
                    let paginationItemFirst = $('<li>').addClass('pagination__item pagination__item--edge');
                    paginationItemFirst.attr('data-page', 1);
                    paginationList.prepend(paginationItemFirst);
                    let paginationLinkFirst = $('<a>').addClass('pagination__link')
                        .attr('href', '#')
                        .text(1);
                    paginationItemFirst.append(paginationLinkFirst);
                    paginationItemFirst.click(function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        ajaxUrl = $(filterForm).attr('action');
                        ajaxUrl = ajaxUrl + '?page=' + page;
                        currentPage = page;
                        scrollToResults();

                        fetchPosts(ajaxUrl, values, nonce, action);
                    });
                }

                //Prev arrow
                let prevItem = $('<li>').addClass('pagination__item__prev');
                let prevLink = $('<a>').addClass('pagination__link__prev')
                    .attr('href', '#')
                    .html(paginationIcon('prev') || '<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M15 6L9 12L15 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>')
                if (parseInt(currentPage) === 1) {
                    prevItem.addClass('disabled');
                } else {
                    prevLink.attr('data-page', parseInt(currentPage) - 1);
                    prevLink.on('click', function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        ajaxUrl = $(filterForm).attr('action');
                        ajaxUrl = ajaxUrl + '?page=' + page;
                        currentPage = page;
                        scrollToResults();

                        fetchPosts(ajaxUrl, values, nonce, action);
                    });
                }

                prevLink.attr('aria-label', $('#pagination').attr('data-label-prev'));
                prevItem.append(prevLink);
                paginationList.prepend(prevItem);
                // Flèche "Suivant"
                let nextItem = $('<li>').addClass('pagination__item__next');
                let nextLink = $('<a>').addClass('pagination__link__next')
                    .attr('href', '#')
                    .html(paginationIcon('next') || '<svg width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
                if (parseInt(currentPage) != maxPages) {
                    nextLink.attr('data-page', parseInt(currentPage) + 1);
                    nextLink.on('click', function (e) {
                        e.preventDefault();
                        let page = $(this).attr('data-page');
                        ajaxUrl = $(filterForm).attr('action');
                        ajaxUrl = ajaxUrl + '?page=' + page;
                        currentPage = page;
                        scrollToResults();

                        fetchPosts(ajaxUrl, values, nonce, action);
                    });
                } else {
                    nextItem.addClass('disabled');
                }
                nextLink.attr('aria-label', $('#pagination').attr('data-label-next'));
                nextItem.append(nextLink);
                paginationList.append(nextItem);
            }

            function fetchPosts(url, values, nonce, action) {
                $('.loader').css('display', 'flex');
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        'action': action,
                        'nonce': nonce,
                        'values': JSON.stringify(values),
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        $('.loader').css('display', 'none');
                        if (data.data.html != '') {
                            if (notFoundContainer) {
                                notFoundContainer.hide();
                            }
                            $('#items-wrapper').html(data.data.html);
                            createPagination(data.data.max_num_pages);
                            $('.pagination__item[data-page="' + currentPage + '"]').addClass('is-active');
                        } else {
                            if (notFoundContainer && $('#items-wrapper').find('.not-found').length === 0) {
                                notFoundContainer.show();
                                $('#items-wrapper').html(notFoundContainer);
                            }
                            $('#pagination').html('');
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }

            fetchPosts(ajaxUrl, values, nonce, action);
        }

    })
})(jQuery);